/**
 * OurApproach Component
 * Visual timeline of the strategic process
 */

import { PROCESS_STEPS } from '../utils/constants';

export function createOurApproach(): string {
  const legacyImage = '/Users/lloyd.vince1985gmail.com/.gemini/antigravity/brain/2cc06dd9-bcbd-449f-bd28-ac1d18b43ffe/happy_wealthy_family_1772988575235.png';

  return `
    <!-- ════════════════════════════════════
         OUR APPROACH
    ════════════════════════════════════ -->
    <section id="approach" style="background:#000000; color:#F8F7F4; position:relative; overflow:hidden;">

      <!-- Subtle background image with overlay -->
      <div style="position:absolute; inset:0; z-index:0; opacity:0.12;">
         <img src="${legacyImage}" alt="" style="width:100%; height:100%; object-fit:cover; filter: grayscale(1) brightness(0.5);">
         <div style="position:absolute; inset:0; background:radial-gradient(circle at 70% 50%, transparent 0%, #000000 100%);"></div>
      </div>

      <!-- Subtle background texture or glow -->
      <div style="position:absolute; top:0; left:0; right:0; height:1px; background:linear-gradient(90deg, transparent, rgba(201, 162, 39, 0.3), transparent); z-index:1;"></div>

      <div style="max-width:1320px; margin:0 auto; padding:0 48px; position:relative; z-index:2;">

        <div style="margin-bottom:80px;">
          <div class="reveal" style="display:flex; align-items:center; gap:18px; margin-bottom:32px;">
            <span class="eyebrow" style="color:#C9A227;">Our Approach</span>
            <div style="height:1px; width:48px; background:#C9A227;"></div>
          </div>
          <h2 class="reveal d1" style="
            font-family:'Cormorant Garamond',serif;
            font-size:clamp(44px, 4.8vw, 64px);
            font-weight:500;
            line-height:1.15;
            color:#F8F7F4;">
            A Lifecycle of <span style="color:#C9A227;">Value Creation</span>
          </h2>
        </div>

        <!-- Horizontal Timeline -->
        <div class="approach-timeline" style="display:grid; grid-template-columns: repeat(3, 1fr); gap:40px; position:relative;">

          <!-- Connecting Line -->
          <div class="approach-connector" style="position:absolute; top:40px; left:0; right:0; height:2px; background:linear-gradient(90deg, rgba(201, 162, 39, 0.5) 0%, rgba(201, 162, 39, 0) 100%); z-index:0; opacity:0.4;"></div>

          ${PROCESS_STEPS.map((step, index) => `
            <div class="reveal approach-step d${index + 1}" style="position:relative; z-index:2;">
              <!-- Circle indicator -->
              <div class="gold-shine" style="width:16px; height:16px; border-radius:50%; background:#C9A227; border:4px solid #000000; margin-bottom:40px; box-shadow: 0 0 15px rgba(201, 162, 39, 0.4);"></div>

              <div style="font-family:'Inter',sans-serif; font-size:16px; font-weight:700; color:#C9A227; margin-bottom:20px; letter-spacing:0.12em; opacity:0.9;">
                STEP ${step.number}
              </div>
              <h3 style="
                font-family:'Cormorant Garamond',serif;
                font-size:36px;
                font-weight:600;
                color:#F8F7F4;
                margin-bottom:20px;">
                ${step.title}
              </h3>
              <p style="
                font-family:'Inter',sans-serif;
                font-size:17px;
                line-height:1.7;
                color:rgba(248,247,244,0.4);">
                ${step.description}
              </p>
            </div>
          `).join('')}
        </div>

      </div>
    </section>
  `;
}

export default createOurApproach;
